import React from 'react';
import { Card, Row, Col, Button, Badge } from 'react-bootstrap';
import { Domain } from '../../pages/ControlDomains';
import { FiPlus, FiEdit2, FiTrash2 } from '../../utils/icons';
import styles from './DomainItem.module.css';

interface DomainItemProps {
  domain: Domain;
  onAddSubdomain: (parentId: number) => void;
  onEdit: (domain: Domain) => void;
  onDelete: (domainId: number) => void;
}

const DomainItem: React.FC<DomainItemProps> = ({ domain, onAddSubdomain, onEdit, onDelete }) => {
  const isParent = domain.parent_id === null;

  const itemContent = (
    <Row className="align-items-center">
      <Col>
        <Badge bg="primary" pill className="me-2">{domain.indice}</Badge>
        {domain.nome}
      </Col>
      <Col xs="auto">
        {isParent && (
          <Button variant="outline-primary" size="sm" onClick={() => onAddSubdomain(domain.id)} title="Adicionar Subdomínio" className="me-2">
            <FiPlus size={16} />
          </Button>
        )}
        <Button variant="outline-secondary" size="sm" onClick={() => onEdit(domain)} title="Editar" className="me-2">
          <FiEdit2 size={16} />
        </Button>
        <Button variant="outline-danger" size="sm" onClick={() => onDelete(domain.id)} title="Excluir">
          <FiTrash2 size={16} />
        </Button>
      </Col>
    </Row>
  );

  return (
    <Card className={isParent ? styles.parentCard : styles.childCard}>
      {isParent ? (
        <Card.Header>{itemContent}</Card.Header>
      ) : (
        <div className={styles.itemContent}>{itemContent}</div>
      )}

      {domain.subdomains && domain.subdomains.length > 0 && (
        <Card.Body className={isParent ? '' : styles.subdomainList}>
          <ul className="list-unstyled">
            {domain.subdomains.map(sub => (
              <li key={sub.id}>
                <DomainItem
                  domain={sub}
                  onAddSubdomain={onAddSubdomain}
                  onEdit={onEdit}
                  onDelete={onDelete}
                />
              </li>
            ))}
          </ul>
        </Card.Body>
      )}
    </Card>
  );
};

export default DomainItem;